// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".configure-view{height:auto;max-width:800px;min-height:100vh;max-height:100vh;margin:0 auto;padding:0 20px}", ""]);
// Exports
module.exports = exports;
